import { Pencil } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../../components/elements/Bar';
import List from '../../../components/elements/List';

export default function ProjectInformationView({ data, makeEditable }) {
  const permission = useSelector((state) => state.auth.pagePermission);

  return (
    <div className="w-full [&_ul]:list-disc [&_ul]:pl-1.5 [&_ol]:list-decimal [&_ol]:pl-1.5">
      <Bar
        text={'Detail'}
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="project-info-edit-btn"
                  onClick={makeEditable}
                />,
              ]
            : []
        }
      />
      <Bar text={'Popis koncepce'} />
      <div className="p-4" dangerouslySetInnerHTML={{ __html: data?.concept_description }} />

      <Bar className="mt-1" text={'Společná poznámka'} content={[]} />
      <div className="p-4" dangerouslySetInnerHTML={{ __html: data?.common_note }} />

      <Bar className="mt-1" text={'Prvky technické zprávy'} content={[]} />
      <List
        data={(data?.classified_technical_report_item_set || []).map((item) => ({
          name: item.title,
          value: '',
        }))}
      />
    </div>
  );
}
